import './styles.scss'
import I18n from 'lib/i18n'
import React, { useEffect } from 'react'
import { useActions, useValues } from 'kea'
import Modal from 'react-responsive-modal'

import sceneLogic from './logic'

export default function EDM () {
  const { eventDialog } = useValues(sceneLogic)
  const { closeModal, initEventDialog, removeDialog } = useActions(sceneLogic)

  const { id, title, description, isModalOpen, eventDialogId, preview, news, system } = eventDialog || {}

  useEffect(() => {
    initEventDialog()
  }, [initEventDialog])

  if (!eventDialog || !isModalOpen) return null

  return (
    <div className='edm-bloc'>
      <Modal
        styles={{
          modal: { padding: '0px' }
        }}
        key={`edm_modal_${id}`}
        center
        open={isModalOpen}
        onClose={system ? closeModal : () => {}}
        showCloseIcon={false}
      >
        <div className='unique-edm-bloc' data-attr='event-dialog-container'>
          <h4 data-attr='title'>{title}</h4>
          <div className='content-bloc'>
            <div className='text-bloc' dangerouslySetInnerHTML={{ __html: description }} data-attr='description' />
            {news ? (
              <button onClick={() => (preview ? closeModal() : removeDialog(eventDialogId))} data-attr='got-it-button'>
                {I18n.t('edm.got_it')}
              </button>
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  )
}
